import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState, NoneOwnProps } from "@multiweb/types/react";
import { LOC_KEY_SEARCH_FIELD_PLACEHOLDER } from "../../locKeys";
import { createSetFocusedItemAction, FORM_SEARCH_INPUT_FOCUSABLE_ID, getSelectAllTextInSearchInput, isFocused } from "../../navigation";
import { createSearchedTextChangedAction, getSearchedText } from "../../search";
import { FormSearchInputComponent, FormSearchInputComponentProps } from "../FormSearchInputComponent";

type StateProps = Pick<FormSearchInputComponentProps, "placeholder" | "value" | "isFocused" | "selectAllText">;

const mapStateToProps: MapStateToProps<StateProps, NoneOwnProps, IAppState> = (state) => ({
    value: getSearchedText(state),
    placeholder: getPrimaryText(state, LOC_KEY_SEARCH_FIELD_PLACEHOLDER),
    isFocused: isFocused(state, FORM_SEARCH_INPUT_FOCUSABLE_ID),
    selectAllText: getSelectAllTextInSearchInput(state),
});

type DispatchProps = Pick<FormSearchInputComponentProps, "onChange" | "onClick">;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, NoneOwnProps> = (dispatch) => ({
    onChange: (searchedText) => dispatch(createSearchedTextChangedAction(searchedText)),
    onClick: () => dispatch(createSetFocusedItemAction(FORM_SEARCH_INPUT_FOCUSABLE_ID)),
});

/**
 * Tvoří kontrolované pole pro vyhledávání - poskytuje aktuální hodnotu a callback pro její změnu. Získává lokalizovaný placeholder.
 */
export const FormSearchInput = connect(mapStateToProps, mapDispatchToProps)(FormSearchInputComponent);
